module.exports = __webpack_public_path__ + "media/src/images/ogp-80768ed6b727565cc76da3c32c48f0b7.jpg";